import { Controller, useFormContext } from 'react-hook-form';

import { ReferenceSitesTooltip } from '@features/campaigns/shared/components/ReferenceSitesTooltip/ReferenceSitesTooltip.tsx';
import { ThematicPackage } from '@features/campaigns/shared/types/thematicPackage.ts';
import { getReferenceSites } from '@features/campaigns/shared/utils/getReferenceSites.ts';
import { UpsellOptionCard } from '@features/campaigns/thematicPackage/components/UpsellOptionCard/UpsellOptionCard.tsx';
import { ThematicPackageUpsellFields } from '@features/campaigns/thematicPackage/containers/ThematicPackageUpsellPage/ThematicPackageUpsellPage.types.ts';
import { PlaceholderCard } from '@shared/components/PlaceholderCard/PlaceholderCard.tsx';

import styles from './FieldThematicPackage.module.scss';

const THEMATIC_PACKAGE_GROUP_NAME = 'thematic-package';

interface FieldThematicPackageProps {
  thematicPackages: ThematicPackage[];
  areThematicPackagesLoading: boolean;
}

export function FieldThematicPackage({ thematicPackages, areThematicPackagesLoading }: FieldThematicPackageProps) {
  const { control } = useFormContext();

  if (areThematicPackagesLoading) {
    return <PlaceholderCard textKey='placeholderLoading' />;
  }

  if (!thematicPackages.length) {
    return <PlaceholderCard textKey='noData' />;
  }

  return (
    <Controller
      control={control}
      name={ThematicPackageUpsellFields.THEMATIC_PACKAGE_ID}
      render={({ field }) => (
        <div className={styles.grid}>
          {thematicPackages.map(({ id, name, sites }, index) => {
            const dataTestId = `thematic-package-${index}`;
            const referenceSites = getReferenceSites(sites);

            return (
              <UpsellOptionCard
                key={id}
                inputId={dataTestId}
                groupName={THEMATIC_PACKAGE_GROUP_NAME}
                value={id}
                label={name}
                tooltip={
                  referenceSites &&
                  referenceSites.secondary.length > 0 && (
                    <ReferenceSitesTooltip targetId={`${dataTestId}-tooltip`} sites={referenceSites.secondary} />
                  )
                }
                isSelected={field.value === id}
                selectCallback={field.onChange}
                dataTestId={dataTestId}
              />
            );
          })}
        </div>
      )}
    />
  );
}
